const MODALS = {
    accountEdit: 'accountEdit',
    deleteBroadcastAudio: 'deleteBroadcastAudio',
    deleteBroadcastImage: 'deleteBroadcastImage',
    hostEdit: 'hostEdit',
    payout: 'payout',
    subscriptionLink: 'subscriptionLink',
    accountDelete: 'accountDelete',
    createBroadcast: 'createBroadcast',
    broadcastAccessLink: 'broadcastAccessLink',
    broadcastImage: 'broadcastImage',
    broadcastAudio: 'broadcastAudio',
    broadcastNote: 'broadcastNote',
    broadcastNotify: 'broadcastNotify',
    socialFlyerImage: 'socialFlyerImage',
};
const PATHNAMES = {
    devices: '/devices',
    home: '/',
    hosts: '/hosts',
    payout: '/payout',
    recommendations: '/recommendations',
    listenerPicks: '/listener-picks',
    broadcasts: '/broadcasts',
    newBroadcast: '/broadcasts/new',
    logout: '/logout',
    socialFlyer: '/social-flyer',
};
const ADMIN_PATHNAMES = [
    PATHNAMES.devices,
    PATHNAMES.home,
    PATHNAMES.hosts,
    PATHNAMES.recommendations,
    PATHNAMES.listenerPicks,
    PATHNAMES.broadcasts,
    PATHNAMES.newBroadcast,
    PATHNAMES.logout,
    PATHNAMES.socialFlyer
];
const HOST_PATHNAMES = [
    PATHNAMES.home,
    PATHNAMES.payout,
    PATHNAMES.broadcasts,
    PATHNAMES.newBroadcast,
    PATHNAMES.logout,
    PATHNAMES.socialFlyer
];
const BROADCAST_DETAIL_PATH_REGEX = new RegExp(/^\/broadcasts\/(?!new)([\w\d]+)$/);
const BROADCAST_STATUS = {
    submitted: "submitted"
};
const MAX_BROADCAST_NOTE_LENGTH = 400;
const NOTIFY_NOTE_CONTENT = "Broadcast submitted for review.";
const IMAGE_GUIDE_LINK = "https://docs.google.com/document/d/e/2PACX-1vQxBOu_A7Z3wsBkC6Nv2jTyd-TaBYf2hG3FVOjPx8P4TWFQtizuUaqarOeq5tpRSRZA0hTpRtRokd3n/pub";
const BROADCAST_ACCESS_TOKEN_KEY = "broadcastAccessToken";
const SIGN_IN_TOKEN_KEY = "signInToken";

module.exports = {
    ADMIN_PATHNAMES,
    HOST_PATHNAMES,
    MODALS,
    PATHNAMES,
    BROADCAST_DETAIL_PATH_REGEX,
    MAX_BROADCAST_NOTE_LENGTH,
    NOTIFY_NOTE_CONTENT,
    IMAGE_GUIDE_LINK,
    BROADCAST_ACCESS_TOKEN_KEY,
    BROADCAST_STATUS,
    SIGN_IN_TOKEN_KEY
};
